function NoAdmin() {
  window.location.replace(process.env.REACT_APP_NO_ADMIN_URI);
  return null;
}

export default NoAdmin;
